import { FC } from "react";
import cn from "classnames";
import styles from "../Scam.module.scss";

interface Props {
    isVisible: boolean;
    setIsVisible(isVisible: boolean): void;
}

const HideButton: FC<Props> = ({ isVisible, setIsVisible }) => {
    return (
        <button onClick={() => setIsVisible(!isVisible)} className={cn(styles.hide, { [styles.active]: isVisible })}>
            <span>Hide</span>
            <img width={9} height={9} src="/images/scam/left.svg" alt="" />
        </button>
    );
};

export default HideButton;
